import { render, staticRenderFns } from "./StatusIcoBtn.vue?vue&type=template&id=e80677e0"
import script from "./StatusIcoBtn.vue?vue&type=script&lang=js"
export * from "./StatusIcoBtn.vue?vue&type=script&lang=js"
import style0 from "./StatusIcoBtn.vue?vue&type=style&index=0&id=e80677e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports